import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ERequestType, RequestApi, WorkbookTypeApi } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { WorkbookTypeDetailPage } from "./WorkbookTypeDetailPage";
import { useGlobalData } from "../../../../contexts";
import { MailLogListPage } from "../../../mail-log/MailLogListPage";

export interface IWorkbookTypeItemPageProps {}

export const WorkbookTypeItemPage: React.FunctionComponent<IWorkbookTypeItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const workbooktypeId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const api = useApiService(WorkbookTypeApi);
  const requestApi = useApiService(RequestApi);
  const { currentLanguage } = useGlobalData();
  const [displayName, loading] = useApiEffect(
    () => api.getDisplayName(workbooktypeId, currentLanguage.languageId),
    [workbooktypeId],
  );
  const [requestInfo, requestInfoLoading, , refreshRequestInfo] = useApiEffect(
    () => requestApi.getRequestInfo(ERequestType.WorkAttestRequest, +id, 0, currentLanguage.languageId),
    [requestApi, id, currentLanguage],
  );
  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.WorkbookType), route: ERoutes.workbookType },
        { text: workbooktypeId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsWorkbookType"
        onChange={(newTabId) => history.push(`${ERoutes.workbookType}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.workbookType} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<WorkbookTypeDetailPage id={workbooktypeId} editMode={state === "edit"} />}
        />
        <Tab
          id="mailing"
          title={t(ETLCodes.Email)}
          panel={requestInfoLoading ? <Spinner /> : <MailLogListPage requestId={requestInfo?.parentRequestId} />}
          disabled={+id <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
